var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVMoments = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsx("path", { d: "M11.094 1.864a1 1 0 0 1 1.272-.23l2.598 1.5a5.992 5.992 0 0 1 2.967 4.564 23.66 23.66 0 0 0 2.11-4.98 1 1 0 1 1 1.918.564c-1.36 4.623-3.843 8.306-6.644 11.154 3.379-.56 6.605 1.852 6.943 5.342l.018.18a1 1 0 0 1-.737 1.063l-2.898.776a6 6 0 0 1-7.272-3.982c-3.062 2.208-6.067 3.55-8.087 4.144a1 1 0 1 1-.564-1.918 18.64 18.64 0 0 0 1.957-.71l-1.208-1.208c-2.622-2.621-2.262-6.97.755-9.125l.147-.105A1 1 0 0 1 5.657 9l2.121 2.121a5.996 5.996 0 0 1 1.59 5.651 28.814 28.814 0 0 0 5.303-4.57l-2.06-1.189c-3.21-1.853-3.988-6.147-1.632-9.01l.115-.139Zm1.053 1.953a4.001 4.001 0 0 0 1.465 5.464l1.816 1.05a4 4 0 0 0-1.464-5.465l-1.817-1.05ZM4.88 16.709l1.483 1.483a4 4 0 0 0 0-5.656L4.88 11.052a4.001 4.001 0 0 0 0 5.657Zm10.37-.215-2.026.543a4 4 0 0 0 4.899 2.828l2.027-.543a4.001 4.001 0 0 0-4.9-2.828Z", fill: "currentColor" })] })));
};
export default SvgVMoments;
